import { render, staticRenderFns } from "./QualificationReview.vue?vue&type=template&id=70957b66"
import script from "./QualificationReview.vue?vue&type=script&lang=js"
export * from "./QualificationReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports